"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.user.exceeded': 'Osiągnięto limit użytkowników. Ulepsz swój plan, aby dodać więcej użytkowników.',
    'limits.user.limitReached': 'Limit użytkowników: {limit} (ulepsz dla więcej)',
};
